// Static placeholder -- there is no billing backend yet. Numbers below are
// sample data purely to match the design; nothing here is wired to a real API.
const SAMPLE_INVOICES = [
  { id: "INV-2026-0912", date: "01 Sep 2026", amount: "$4,280.00" },
  { id: "INV-2026-0811", date: "01 Aug 2026", amount: "$4,556.00" },
  { id: "INV-2026-0710", date: "01 Jul 2026", amount: "$4,102.00" },
];

const BillingTab = () => (
  <div>
    <div className="mb-5">
      <h3 className="text-base font-bold text-gray-900">Billing</h3>
      <p className="text-sm text-gray-500">Plan, usage and invoice history for this facility</p>
      <p className="mt-1 text-xs italic text-gray-400">Sample data &mdash; billing is not yet connected to a live source.</p>
    </div>

    <div className="mb-6 grid grid-cols-1 gap-4 md:grid-cols-3">
      <div className="rounded-xl border border-gray-100 p-5">
        <p className="text-xs font-semibold uppercase tracking-wide text-gray-400">Plan</p>
        <p className="mt-1 text-xl font-bold text-gray-900">Enterprise</p>
        <p className="text-xs text-gray-500">Renews 1 Oct 2026</p>
      </div>
      <div className="rounded-xl border border-gray-100 p-5">
        <p className="text-xs font-semibold uppercase tracking-wide text-gray-400">Tokens this cycle</p>
        <p className="mt-1 text-xl font-bold text-gray-900">
          128.4M <span className="text-sm font-normal text-gray-400">of 500M</span>
        </p>
        <div className="mt-2 h-1.5 w-full rounded-full bg-gray-100">
          <div className="h-1.5 rounded-full bg-[#2B3674]" style={{ width: "26%" }} />
        </div>
      </div>
      <div className="rounded-xl border border-gray-100 p-5">
        <p className="text-xs font-semibold uppercase tracking-wide text-gray-400">Current spend</p>
        <p className="mt-1 text-xl font-bold text-gray-900">$4,280</p>
        <p className="text-xs text-green-600">↓ 6% vs last cycle</p>
      </div>
    </div>

    <h4 className="mb-3 text-sm font-bold text-gray-900">Recent invoices</h4>
    <div className="divide-y divide-gray-100 rounded-xl border border-gray-100">
      {SAMPLE_INVOICES.map((invoice) => (
        <div key={invoice.id} className="flex items-center justify-between px-5 py-3 text-sm">
          <span className="font-medium text-gray-900">{invoice.id}</span>
          <div className="flex items-center gap-6">
            <span className="text-gray-500">{invoice.date}</span>
            <span className="font-semibold text-gray-900">{invoice.amount}</span>
            <span className="rounded-full bg-green-100 px-2.5 py-1 text-xs font-semibold text-green-700">Paid</span>
          </div>
        </div>
      ))}
    </div>
  </div>
);

export default BillingTab;
